import { Component, type ReactNode } from 'react';
import { Translation } from 'react-i18next';
import { SupportAction } from './SupportAction';
import styles from './AsyncState.module.css';
import { Button } from './Button';

export class AppErrorBoundary extends Component<{children: ReactNode}, {failed: boolean}> {
  state = {failed:false};
  static getDerivedStateFromError() { return {failed:true}; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <Translation>{(t) => <section className={styles.error}><h2>{t('ui.appErrorBoundary.title')}</h2>
      <p>{t('ui.appErrorBoundary.hint')}</p>
      <Button variant="brand" className={styles.retry} onClick={() => window.location.reload()}>{t('ui.appErrorBoundary.reload')}</Button>
      <SupportAction />
    </section>}</Translation>;
  }
}
